import { FunctionComponent } from 'react';

import { PoweredByAssemblyBranding } from 'src/legacy/components/Icons/PoweredByAssemblyBranding';

export const AuthScreenPortalBadgeIcon: FunctionComponent = () => {
  const iconClassName = 'text-gray-small group-hover:text-black-heading h-3.5';
  return <PoweredByAssemblyBranding className={iconClassName} />;
};
